new WOW().init();

// ========================== Add Common-Home Class On Body Tag ==========================
document.addEventListener("DOMContentLoaded", function () {
  var slideshowElement = document.getElementById("tb-home-slideshow");
  if (slideshowElement) {
    document.body.classList.add("common-home");
  }
});

// ========================== BACK TO TOP ==========================
$(window).scroll(function () {
  if ($(this).scrollTop() >= 50) {
    $("#return-to-top").fadeIn(200);
  } else {
    $("#return-to-top").fadeOut(200);
  }
});
$("#return-to-top").click(function () {
  $("body,html").animate(
    {
      scrollTop: 0,
    },
    500
  );
});

// ========================== MENU-CLICK HIDE MENU DROPDOWN ==========================
$(document).ready(function () {
  $(".list-menu__item").on("click", function () {
    $("#Details-menu-drawer-container").removeAttr("open");
    $(".header__icon").attr("aria-expanded", "false");
    $("body").removeClass("overflow-hidden-tablet");
    $(".menu-opening").removeClass("menu-opening");
  });
});

// ========================== CUSTOMERS OWL-CAROUSEL ==========================
$(document).ready(function () {

  $("#tb-home-slideshow .swiper-wrapper").owlCarousel({
    items: 1,
    nav: false,
    dots: false,
    // loop: true,
    autoplayHoverPause: true,
    autoplay: false,
    mouseDrag: false,   
    touchDrag: false,    
    pullDrag: false,      
    freeDrag: false, 
    responsive: {
      0: { items: 1 },
      544: { items: 1 },
      768: { items: 1 },
      992: { items: 1 },
      1200: { items: 1 },
    },
  });
  
   $("#TB-phase-cms .owl-carousel").owlCarousel({
            items: 3,
            loop: false,
            nav: false,
            dots: true,
            margin: 30,
            responsive: {
                0: {
                    items: 1,
                    margin: 15,
                },
                576: {
                    items: 2,
                    margin: 15,
                },
                768: {
                    items: 2,
                    margin: 15,
                },
                992: {
                    items: 3,
                    margin: 30,
                }
            }
        });

     $("#TB-testimonial .owl-carousel").owlCarousel({
            items: 3,
            loop: false,
            nav: false,
            dots: true,
            margin: 30,
            responsive: {
                0: {
                    items: 1,
                    margin: 15,
                },
                576: {
                    items: 2,
                    margin: 15,
                },
                768: {
                    items: 2,
                    margin: 15,
                },
                992: {
                    items: 3,
                    margin: 30,
                }
            }
        });

        $("#TB-result-cms .owl-carousel").owlCarousel({
            items: 1,
            loop: true,
            nav: false,
            dots: true,
            margin: 30,
            animateOut: 'fadeOut',
            mouseDrag: false,
            touchDrag: false,
            pullDrag: false,
            freeDrag: false,
            autoplay:true,
            autoplayHoverPause: true,
            autoplayTimeout: 3000,
        });
});

// ========================== RELATED PRODUCT OWL-CAROUSEL ==========================
$(document).ready(function () {
  $("#productThumbs").owlCarousel({
    items: 4,
    margin: 15,
    nav: true,
    dots: false,
    loop: false,
    responsive: {
      0: {
        items: 2,
      },
      481: {
        items: 3,
      },
      576: {
        items: 4,
      },
      768: {
        items: 5,
      },
      992: {
        items: 3,
      },
      1300: {
        items: 4,
      },
    },
  });
});

// ========================== FOOTER TOGGLE ==========================
function footerToggle() {
  if ($(window).width() < 992) {
    $(".tb-footer-center .footer-column h5").addClass("toggle");
    $(".tb-footer-center .footer-column h5.toggle").unbind("click");
    var Accordions = function (el, multiple) {
      this.el = el || {};
      this.multiple = multiple || false;
      var link = this.el.find(".toggle");
      link.on("click", { el: this.el, multiple: this.multiple }, this.dropdown);
    };
    Accordions.prototype.dropdown = function (e) {
      var $el = e.data.el;
      ($this = $(this)), ($next = $this.next());
      $next.slideToggle();
      $this.parent().toggleClass("active");
      if (!e.data.multiple) {
        $el
          .find(".tb-footer-center .footer-column")
          .not($next)
          .slideUp()
          .parent()
          .removeClass("active");
      }
    };
    var accordions = new Accordions(
      $(".tb-footer-center .footer-column"),
      false
    );
  } else {
    $(".tb-footer-center .footer-column h5.toggle").unbind("click");
    $(".tb-footer-center .footer-column h5").removeClass("toggle");
  }
}
$(document).ready(function () {
  footerToggle();
});
$(window).resize(function () {
  footerToggle();
});

// ========================== RELATED PRODUCT ==========================
$(document).ready(function () {
  // Add active class to the first image by default
  $(".tb-related-product:first").parent().addClass("active");

  // Attach click event listener to each related product thumbnail
  $(".tb-related-product").click(function () {
    // Remove active class from all related product thumbnails and their parent containers
    $(".tb-related-product").parent().removeClass("active");

    // Add active class to the clicked related product thumbnail and its parent container
    $(this).addClass("active").parent().addClass("active");

    // Get the URL of the clicked thumbnail's image
    var thumbnailSrc = $(this).attr("src");

    // Update the source attribute of the main product image
    // $('.zoom').css('background-image', 'url(' + thumbnailSrc + ')');
    $("#productPhotoImg").attr("src", thumbnailSrc);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Add event listener for mouseenter event on .zoom element
  var zoomElement = document.querySelector(".zoom");
  if (zoomElement) {
    zoomElement.addEventListener("mouseenter", function () {
      // Get the URL of the main product image
      var img_url = document
        .getElementById("productPhotoImg")
        .getAttribute("src");
      // Set background image of .zoom element to the main product image
      this.style.backgroundImage = "url(" + img_url + ")";
    });

    // Add event listener for mouseleave event on .zoom element
    zoomElement.addEventListener("mouseleave", function () {
      // Remove background image when mouse leaves the .zoom element
      this.style.backgroundImage = "none";
    });
  }
});

function zoom(e) {
  var zoomer = e.currentTarget;
  e.offsetX ? (offsetX = e.offsetX) : (offsetX = e.touches[0].pageX);
  e.offsetY ? (offsetY = e.offsetY) : (offsetY = e.touches[0].pageY);
  x = (offsetX / zoomer.offsetWidth) * 100;
  y = (offsetY / zoomer.offsetHeight) * 100;
  zoomer.style.backgroundPosition = x + "% " + y + "%";
}



/* ------------ Start TemplateBunch Parallax JS ------------ */
  var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
      navigator.userAgent
  );
  if (!isMobile) {
      if ($("#TB-ingredients-cms").length) {
          $("#TB-ingredients-cms").sitManParallex({ invert: false });
      }
  } else {
      $("#TB-ingredients-cms").sitManParallex({ invert: true });
  }
/* ------------ End TemplateBunch Parallax JS ------------ */
